module.exports = __webpack_public_path__ + "static/media/events.fb9257dc.webp";